import React from "react";

import BEM from "./Task.module.scss";

export const Task = ({ onComplete, buttonColor = "#fff", title, nextDate }) => {
  return (
    <div className={BEM.block}>
      <button onClick={onComplete} className={BEM.completeBtn}>
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="5.5" cy="5.5" r="5" stroke={buttonColor} />
        </svg>
      </button>
      <span className={BEM.title}>{title}</span>
      <span className={BEM.nextDate}>{nextDate}</span>
    </div>
  );
};
